<template>
  <div class="MamoriatDetails">
    <v-row>
      <v-col cols="6"
        >{{
          $t("PeriodWorkDetails.MamoriatDetails.lblHozorDarMamoriateRozane")
        }}:<span class="text-value">{{
          ConvertMinuteToHour(details.PRESENCEINDMAM)
        }}</span></v-col
      >
      <v-col cols="6"
        >{{ $t("PeriodWorkDetails.MamoriatDetails.lblMamoriat") }}:<span
          class="text-value"
          >{{ ConvertMinuteToHour(details.MISSION) }}</span
        ></v-col
      >
      <v-col cols="12">
        <box class="mt-2" title="<small>ریز ماموریت</small>">
          <div class="">
            <v-data-table
              dense
              :headers="periodMissionDetailsHeader"
              :items="periodMissionDetails"
            ></v-data-table>
          </div>
        </box>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: ["details"],
  data() {
    return {
      periodMissionDetails: [],
      periodMissionDetailsHeader: [
        {
          text: this.$t("missionType"),
          value: "NAME",
        },
        {
          text: this.$t("missionAmount"),
          value: "mizan",
        },
      ],
    };
  },
  watch: {
    details(newVal) {
      if (newVal.PERIOD) {
        this.GetPeriodMissionDetail();
      }
    },
  },
  mounted() {
    if (this.details.PERIOD) {
      this.GetPeriodMissionDetail();
    }
  },
  methods: {
    GetPeriodMissionDetail() {
      const GetPeriodMissionDetailParams = {
        period: this.details.PERIOD,
        year: this.details.year,
        isPeriod: this.details.isPeriod,
      };

      if (this.details.PERNO) {
        GetPeriodMissionDetailParams.perno = this.details.PERNO;
      }

      this.$store
        .dispatch("GetPeriodMissionDetail", { GetPeriodMissionDetailParams })
        .then((result) => {
          ////console.log(result);
          if (result.type === "success") {
            this.periodMissionDetails = result.data.Table;
          }
        });
    },
  },
};
</script>

<style>
</style>